import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Autoplay, EffectCoverflow, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import HoliData2025 from "../../../../../../Data/Events/2025/HoliData2025";
import "../../CSSBlogs/MainBlogsCSSFile.css";

const Holi2025 = () => {
    return (
        <>
            <section className="carousel_slider_section">
                <div className="container carouselSliderFirstInnerDiv">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                        <Swiper
                                effect={"coverflow"}
                                grabCursor={true}
                                centeredSlides={true}
                                slidesPerView={"auto"}
                                coverflowEffect={{
                                    rotate: 0,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 2,
                                    // slideShadows: true,
                                }}
                                // pagination={{
                                //     clickable: true,
                                //     dynamicBullets: true,
                                // }}
                                loop={true}
                                autoplay={{ delay: 3000 }}
                                navigation={true}
                                modules={[EffectCoverflow, Navigation, Autoplay]}
                                className="mySwiper"
                            >
                                {
                                    HoliData2025.map((items) => {
                                        return (
                                            <SwiperSlide className="swiperSlide" key={items.id}>
                                                <div className="swiper-slide-img">
                                                    <img src={items.imageSource} alt="Avatar" className='nexus' />
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
            <section className="blogs-heading-and-para-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 blog-heading-and-para-div">
                            <h1>Happy Holi #2025</h1>
                            <p>Holi is a vibrant festival of color and love, one of the most widely recognized festivals celebrated in India and other parts of the world. It is a joyous occasion marked by vibrant colors, delicious food, and a sense of togetherness among people of all ages and backgrounds.</p>
                            <p>In Holistic Learning, we came together with a spectrum of colors to celebrate this vibrant <b style={{color: "rgba(187, 61, 39, 0.95)"}}>festival of color on 13th March 2025</b>. However, we focused on themes of the spectrum where everyone came with colorful themes and clothes that showcased the beauty of color in nature in the overall week.</p>
                            <p>The actual celebration began with lunch planned everyone settled down for small interesting games as planned earlier, we started to guess different colors on different sheets and then Charades were played in teams, and the celebration commenced with the drinking of Thandai, a traditional Indian beverage adorned with almonds and pistachios that is known for its invigorating properties.</p>
                            <p>We prepare to color each other with a game called Strops. In this game, the player is presented with a series of words that are written in different colors. In charades, everyone's ears were locked with music and other team members had to pronounce the words and guessed by others. After this, every one of us played with colors and celebrated Holi by coloring everyone.</p>
                        </div>
                        <div className="col-md-6 blog-writer-div">
                            <p>Written By ~ Priyankesh M</p>
                        </div>
                        <div className="col-md-6 blog-button-div">
                            <NavLink to={"/events/more-events"} className="href">
                                <button>
                                    <span className="icon">
                                        <FaArrowLeft />
                                    </span>{" "}
                                    View All Events
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Holi2025;
